module.exports = __webpack_public_path__ + "img/service-11.2c0719df.jpg";